import { App } from 'vue'
// import Cabinet from './cabinet/views/Cabinet.vue'
// import FiltersModal from './cabinet/components/modals/FiltersModal.vue'
import AuthWrapper from './auth/AuthWrapper.vue'
import AccessDenied from './errors/403/AccessDenied.vue'
import NotFound from './errors/404/NotFound.vue'
const register = (app: App<Element>): void => {
  app
  // .component('Cabinet', Cabinet)
  .component('AuthWrapper', AuthWrapper)
  .component('AccessDenied', AccessDenied)
  .component('NotFound', NotFound)
  // .component('FiltersModal', FiltersModal)
}

export default {
  register,
}
